import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { styled } from '@classify/react-core-components/styles';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
const PREFIX = 'SearchField';
const classes = {
  root: `${PREFIX}-root`,
  input: `${PREFIX}-input`,
  searchIcon: `${PREFIX}-searchIcon`,
  resetIcon: `${PREFIX}-resetIcon`
};
const Root = styled('div')(/* istanbul ignore next */({
  theme: {
    spacing,
    palette,
    typography,
    shape
  }
}) => ({
  [`&.${classes.root}`]: {
    position: 'relative',
    width: '100%'
  },
  [`& .${classes.input}`]: {
    width: '100%',
    border: `1px solid ${palette.layout.line.divider}`,
    padding: spacing(1, 5, 1, 1),
    boxSizing: 'border-box',
    borderRadius: shape.borderRadius,
    ...typography.body1,
    lineHeight: `${'1.4rem'} !important`,
    fontSize: `${'1rem'} !important`
  },
  [`& .${classes.searchIcon}`]: {
    position: 'absolute',
    top: spacing(1),
    right: spacing(1)
  },
  [`& .${classes.resetIcon}`]: {
    position: 'absolute',
    color: palette.text.onMain,
    top: -3,
    right: -1
  }
}));
export default function SearchField(t0) {
  const $ = _c(26);
  let otherProps;
  let t1;
  let t2;
  let t3;
  let translations;
  if ($[0] !== t0) {
    ({
      onChange: t1,
      hasSearchIconHidden: t2,
      shouldAutoFocus: t3,
      translations,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = translations;
  } else {
    otherProps = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    translations = $[5];
  }
  const onChange = t1 === undefined ? _temp : t1;
  const hasSearchIconHidden = t2 === undefined ? false : t2;
  const shouldAutoFocus = t3 === undefined ? false : t3;
  const [value, setValue] = useState("");
  const inputElement = useRef(null);
  const timeout = useRef(null);
  let t4;
  if ($[6] !== onChange) {
    t4 = event => {
      const {
        value: newValue
      } = event.target;
      setValue(newValue);
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
      timeout.current = setTimeout(() => {
        timeout.current = null;
        onChange(newValue);
      }, 250);
    };
    $[6] = onChange;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onThrottledChange = t4;
  let t5;
  if ($[8] !== shouldAutoFocus) {
    t5 = () => {
      if (!inputElement || !shouldAutoFocus) {
        return;
      }
      inputElement.current.focus();
    };
    $[8] = shouldAutoFocus;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [inputElement];
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== hasSearchIconHidden) {
    t7 = hasSearchIconHidden ? null : <SearchIcon className={classes.searchIcon} data-testid="visual-icon" />;
    $[11] = hasSearchIconHidden;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const decorativeSearchIcon = t7;
  let t8;
  if ($[13] !== onThrottledChange || $[14] !== otherProps || $[15] !== translations.inputSearchPlaceholder || $[16] !== value) {
    t8 = <input ref={inputElement} value={value} placeholder={translations.inputSearchPlaceholder} onChange={onThrottledChange} type="text" className={classes.input} spellCheck="false" autoComplete="off" {...otherProps} />;
    $[13] = onThrottledChange;
    $[14] = otherProps;
    $[15] = translations.inputSearchPlaceholder;
    $[16] = value;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== decorativeSearchIcon || $[19] !== onChange || $[20] !== translations.resetButtonLabel || $[21] !== value) {
    t9 = value ? <IconButton aria-label={translations.resetButtonLabel} className={classes.resetIcon} onClick={() => {
      setValue("");
      onChange("");
    }} size="large"><CloseIcon /></IconButton> : decorativeSearchIcon;
    $[18] = decorativeSearchIcon;
    $[19] = onChange;
    $[20] = translations.resetButtonLabel;
    $[21] = value;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <Root className={classes.root}>{t8}{t9}</Root>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp() {}